import { applyMiddleware, compose, createStore } from "redux";
import { persistStore } from "redux-persist";
import thunk from "redux-thunk";
import axios from "axios";
import { composeWithDevTools } from "redux-devtools-extension";
import reducers from "../rootReducer";
import API from "../../utility/endpoints";

const axiosInstance = axios.create({
  baseURL: API.baseUrl,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const enhancers = compose(
  composeWithDevTools(applyMiddleware(thunk.withExtraArgument(axiosInstance)))
);
let store;
const isClient = typeof window !== "undefined";

if (isClient) {
  const { persistReducer } = require("redux-persist");
  const storage = require("redux-persist/lib/storage/session").default;

  const persistConfig = {
    key: "root",
    storage,
  };

  store = createStore(persistReducer(persistConfig, reducers), enhancers);

  store.__PERSISTOR = persistStore(store);
} else {
  store = createStore(reducers, enhancers);
}

export default store;
